
<div :class="classes(n(), n(`--${direction}`))">
  <slot />
</div>
